module.exports = __webpack_public_path__ + "media/images/iconBell__inactive-39e1eea21bcb02cf4e1e41dfa92f15b4.png";